import React from 'react';

export const CreditHistoryPage = () => {
  return (
    <div className='margin-horizontal-l margin-vertical-l padding-bottom-xxl'>
      <h1>Credit history page</h1>
    </div>
  );
};
